// extracted by mini-css-extract-plugin
export var container = "NavSection-module--container--QdL0s";
export var toggle = "NavSection-module--toggle--x6HSR";
export var fixed = "NavSection-module--fixed--v2k8N";
export var chevronDown = "NavSection-module--chevron-down--3TstD";
export var dropdown = "NavSection-module--dropdown--PMZnD";